export default "__VITE_ASSET__DwheJH_A__"